import React, { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Button, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import useDidMountEffect from '../../../../hooks/useDidMountEffect';
import apiService from '../../../../api/apiService';
import DataContext from '../../../../context/DataContext';
import notifyService from '../../../../api/notifySerivce';
import { Link } from 'react-router-dom';
import { FileUploader } from 'react-drag-drop-files';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Viewimage from '../../../../api/Viewimage';
const fileTypes = ["pdf"];

const FddSectionF = () => {
  const [formData, setFormData] = useState({});
  const { handleBackapp, setPageLoading,navigator } = useContext(DataContext)
  const { handleSubmit, setValue, getValues, clearErrors, control, formState: { errors } } = useForm({
    values: formData,
  });
  const [readyOnlyValue, setReadyOnlyValue] = useState(false);
  useDidMountEffect(() => {
    getApi()
  }, [])
  const [Investors, setInvestors] = useState();
  const [roc, setROC] = useState();
  const [fileUploadId, setFileUploadId] = useState(0)
  const getApi = async () => {
    setPageLoading(true)
    await apiService(`startup/fdd/secf/get`, '', 'get').then((res) => {
      if (res && res.data) {
        var data = res.data
        if (res.data.id) {
          setFileUploadId(res.data.id)
        }
        setFormData(res.data)
      }
      setPageLoading(false)
    })
  }

  const handleInvoice = (e) => {
    handleFileUpload(e, "invoice", "invoiceName", "invoiceURL", 'file');
  }
  const handleVerificationStatement = (e) => {
    handleFileUpload(e, "verificationStatement", "verificationStatementName", "verificationStatementURL", 'file');
  }
  const handleLatestVerificationStatement = (e) => {
    handleFileUpload(e, "latestVerificationStatement", "latestVerificationStatementLatestName", "latestVerificationStatementURL", 'file');
  }
  const handleDetailsOfAssests = (e) => {
    handleFileUpload(e, "detailsOfAssests", "detailsOfAssestsName", "detailsOfAssestsURL", 'file');
  }
  const handleAmountCapitalized = (e) => {
    handleFileUpload(e, "amountCapitalized", "amountCapitalizedName", "amountCapitalizedURL", 'file');
  }
  const handleCopyRights = (e) => {
    handleFileUpload(e, "copyRights", "copyRightsName", "copyRightsURL", 'file');
  }
  const handleForeginCurrencyAssests = (e) => {
    handleFileUpload(e, "foreginCurrencyAssests", "foreginCurrencyAssestsName", "foreginCurrencyAssestsURL", 'file');
  }
  const handleFixedDepositRecipts = (e) => {
    handleFileUpload(e, "fixedDepositRecipts", "fixedDepositReciptsName", "fixedDepositReciptsURL", 'file');
  }


  const handleFileUpload = (event, filekey, fileName, fileURL, format) => {
    let logoselecetdFile;
    if (event !== null) {
      if (event.target === undefined) {
        logoselecetdFile = event
      } else {
        logoselecetdFile = event.target.files[0]
      }
      if (logoselecetdFile) {
        const fileSizeLimit = 5 * 1024 * 1024;
        if (logoselecetdFile.size > fileSizeLimit) {
          notifyService(
            "danger",
            "File Size Exceeded",
            "Please upload a file smaller than 5 MB."
          );
          return;
        }
        var reader = new FileReader();
        var imagetype = logoselecetdFile.type
        var imagedatatype = imagetype.split("/")
        var img_crt_type = imagedatatype[1]
        if (
          ((format === 'file') && (img_crt_type === "pdf")) ||
          ((format === 'excel') && (img_crt_type === "vnd.ms-excel" || img_crt_type === "vnd.openxmlformats-officedocument.spreadsheetml.sheet"))
        ) {
          setValue(filekey, "")
          setValue(fileName, "")

          var fileValue = logoselecetdFile
          reader.readAsDataURL(logoselecetdFile);
          reader.onload = () => {
            var logourl1 = reader.result;
            var spl = logourl1.split(',')
            var ImageValue = spl[1]
            var img_name = fileValue.name
            setValue(filekey, ImageValue)
            setValue(fileName, img_name)
            setValue(fileURL, logourl1)
            clearErrors(filekey);
            clearErrors(fileName);
            clearErrors(fileURL);
            var req = {
              [filekey]: ImageValue,
              [fileName]: img_name,
              id: fileUploadId
            }
            console.log(req);
            // saveData(req)
          }
        } else {
          notifyService('danger', 'File Format Invalided', 'Please check your file format')
        }
      }
    }
  }

  const [open, setOpen] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const handleClickOpen = (value) => {
    if (value) {
      setViewImage(value);
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = (data) => {
    console.log(data);
    setPageLoading(true);
    apiService('startup/fdd/secf/save', data, 'post').then((res) => {
      setPageLoading(false);
      if (res && res.data) {
        if (res.data.responseStatus === "Success") {
          notifyService('success', 'Success', 'Saved successfully !!')
          navigator("/startup/scst/fdd-document/section-g");
        }
      }
    })
  }
  return (
    <>
      <section className='container-fluid'>
        <div className='form_div'>
          <div className="d-flex align-items-center">
            <span className="back_span" onClick={handleBackapp}>
              <img src='/images/Fig-back.png' className='img-fluid' alt='' />
            </span>
            <h6 className="ml-2 mb-0">Fixed Assets Startupscst fixed Assets</h6>
          </div>
          <hr />
          <form className="signin-form" onSubmit={handleSubmit(onSubmit)}>

            <div className="row doc-row2">
           
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Copies of Invoices for the Current Year for Major Purchases</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="invoice" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleInvoice}
                          value={getValues('invoice')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('invoice') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('invoice') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('invoice') !== '' ? 'Uploaded (Click to Change)' : 'Invoice Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.termSheet && errors.termSheet.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('invoiceURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Share the copies of Physical Verification Statements done in the past</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="verificationStatement" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleVerificationStatement}
                          value={getValues('verificationStatement')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('verificationStatement') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('verificationStatement') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('verificationStatement') !== '' ? 'Uploaded (Click to Change)' : 'Physical Verification Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.verificationStatement && errors.verificationStatement.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('verificationStatementURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Physical Verification Statement of the fixed asset available as on any latest date issued prior to the commencement of the Due Diligence.</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="latestVerificationStatement" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleLatestVerificationStatement}
                          value={getValues('latestVerificationStatement')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('latestVerificationStatement') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('latestVerificationStatement') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('latestVerificationStatement') !== '' ? 'Uploaded (Click to Change)' : 'Latest Verification Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.latestVerificationStatement && errors.latestVerificationStatement.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('latestVerificationStatementURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Details of fixed assets which are there in the books but not used or not in working condition</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="detailsOfAssests" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleDetailsOfAssests}
                          value={getValues('detailsOfAssests')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('detailsOfAssests') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('detailsOfAssests') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('detailsOfAssests') !== '' ? 'Uploaded (Click to Change)' : 'Fixed Assets  Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.detailsOfAssests && errors.detailsOfAssests.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('detailsOfAssestsURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Expenses break up for the Amount Capitalized as Intangibles.</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="amountCapitalized" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleAmountCapitalized}
                          value={getValues('amountCapitalized')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('amountCapitalized') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('amountCapitalized') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('amountCapitalized') !== '' ? 'Uploaded (Click to Change)' : 'Amount Capitalized Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.amountCapitalized && errors.amountCapitalized.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('amountCapitalizedURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>List of material patents, copyrights, licenses, trade secrets, trade names and trademarks whether registered (issued and pending) or unregistered.</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="copyRights" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleCopyRights}
                          value={getValues('copyRights')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('copyRights') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('copyRights') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('copyRights') !== '' ? 'Uploaded (Click to Change)' : 'Trademarks  Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.copyRights && errors.copyRights.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('copyRightsURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Foreign Currency Assets, Liabilities & transaction.</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="foreginCurrencyAssests" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleForeginCurrencyAssests}
                          value={getValues('foreginCurrencyAssests')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('foreginCurrencyAssests') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('foreginCurrencyAssests') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('foreginCurrencyAssests') !== '' ? 'Uploaded (Click to Change)' : 'Foreign Currency  Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.foreginCurrencyAssests && errors.foreginCurrencyAssests.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('foreginCurrencyAssestsURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4  col-12 mt-2'>
                <FormLabel>Copies of Fixed Deposit Receipts, Shares or any other securities and investments & interest statement for the same.</FormLabel>
                <div className="d-flex align-items-center">
                  <div className='form-group my-1'>
                    <Controller name="fixedDepositRecipts" control={control} defaultValue="" rules={{ required: false }}
                      render={({ field }) =>
                        <FileUploader
                          {...field}
                          handleChange={handleFixedDepositRecipts}
                          value={getValues('fixedDepositRecipts')}
                          name="file"
                          types={fileTypes}
                          children={
                            <div className={getValues('fixedDepositRecipts') !== '' ? 'fileupload-pdf-dpiit-bg1-active' : 'fileupload-pdf-dpiit-bg1'}>
                              <center>
                                <p className={getValues('fixedDepositRecipts') !== '' ? 'fileupload-pdf-active' : 'fileupload-pdf'}>
                                  <span>
                                    <AttachFileIcon className="file-icon mr-2" />
                                    {getValues('fixedDepositRecipts') !== '' ? 'Uploaded (Click to Change)' : 'Fixed Deposit Document'}
                                  </span>
                                </p>
                              </center>
                            </div>
                          }
                          disabled={readyOnlyValue}
                        />
                      } />
                    <FormHelperText className="ml-2">Maximum size: 5 MB. File format .pdf</FormHelperText>
                    <FormHelperText sx={{ marginLeft: '5px' }} className='text-danger'>{errors.fixedDepositRecipts && errors.fixedDepositRecipts.message}</FormHelperText>
                  </div>
                  <span className="pre-btn-dpiit"><VisibilityIcon className='icon-size mr-1' /><Link

                    onClick={() => handleClickOpen(getValues('fixedDepositReciptsURL'))}
                    style={{ color: "#80809e" }}
                  > Preview
                  </Link>
                  </span>
                </div>
              </div> 
              <div className='col-lg-4 col-12 mt-2'>
                <div className="form-group mt-2">
                  <Controller
                    name="assestsRegister"
                    control={control}
                    defaultValue=""
                    rules={{ required: false }}
                    render={({ field }) => (
                      <TextField
                        variant="outlined"
                        label="Fixed Assets Register"
                        placeholder="Enter Details"
                        fullWidth
                        multiline
                        {...field}
                      />
                    )}
                  />
                  <FormHelperText className="text-danger">
                    {errors.assestsRegister && errors.assestsRegister.message}
                  </FormHelperText>
                </div>
              </div>
              <div className='col-lg-4 col-12'>
                <div className="form-group">
                  <FormLabel>Do you have a system of Periodical Verification of Fixed Assets</FormLabel>
                  <Controller name="periodicalVerification" control={control} defaultValue="" rules={{ required: false }}
                    render={({ field }) =>
                      <RadioGroup
                        row
                        name="position"
                        {...field}
                      >
                        <FormControlLabel disabled={readyOnlyValue} onChange={(e) => { setInvestors(e.target.value) }} defaultValue='null' value='true' control={<Radio />} label="Yes" />
                        <FormControlLabel disabled={readyOnlyValue} onChange={(e) => { setInvestors(e.target.value); setValue('auditors', '') }} defaultValue='null' value='false' control={<Radio />} label="No" />

                      </RadioGroup>
                    } />
                  <FormHelperText className='text-danger'>{errors.periodicalVerification && errors.periodicalVerification.message}</FormHelperText>
                </div>
              </div>
            </div>


            <div className="form-group d-flex justify-content-end mt-3 mr-2">
              <Button variant="contained" onClick={handleBackapp} className="btn btn-cancel submit px-3">Cancel</Button>
              {
                (readyOnlyValue === false) ? (
                  <Button
                    type="submit"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    className="btn btn-primary submit px-3 ml-3"
                  >
                    <span>Save & Proceed Next</span>
                  </Button>
                ) : (<></>)
              }

            </div>
          </form>
        </div>
        <Viewimage viewImage={viewImage} open={open} handleClose={handleClose} />
      </section>
    </>
  )
}

export default FddSectionF